import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { KmContextSource } from '@/entities/expert-report-km';

/** Подпись уровней, с которых приходит атрибут контекста оценки */
export const useFormatKmContextSources = () => {
  const { t } = useTranslation('expertReport');

  return useCallback(
    (sources: KmContextSource[]) =>
      sources.map((source) => (source.kind === 'report' ? t('km.reportContext') : source.name)).join(', '),
    [t],
  );
};
